import {Icon} from '@iconify/react';
import React, {PropsWithChildren, useRef} from 'react';
import {ELEMENT} from '../../incase-domain/elements/base/ElementTypes';
import {setElementDragPayload} from '../../utils/elementDragDrop';

interface ElementBoxProps {
    icon: string;
    element: string;
    type: ELEMENT;
    elementProps?: Record<string, unknown>;
    onMouseUp?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function ElementBox(props: PropsWithChildren<ElementBoxProps>): JSX.Element {
    const {icon, element, type, elementProps, onMouseUp} = props;
    const didDragRef = useRef(false);

    return (
        <button
            draggable
            onDragStart={(e) => {
                didDragRef.current = true;
                setElementDragPayload(e.dataTransfer, {type, elementProps});
            }}
            onDragEnd={() => {
                // Defer reset so a trailing mouseUp after drag can still see didDrag
                requestAnimationFrame(() => {
                    didDragRef.current = false;
                });
            }}
            onMouseUp={(e) => {
                if (didDragRef.current) {
                    didDragRef.current = false;
                    return;
                }
                onMouseUp?.(e);
            }}
            type="button"
            data-cy={type}
            className="c-elementBox u-flex u-flex-col u-h-center u-v-center u-gap-2"
        >
            <Icon icon={icon} className="c-elementBox_icon" />
            <div className="c-elementBox_elementName">{element}</div>
        </button>
    );
}

export default ElementBox;
